const f={background:{default:"#f7f5f3",main:"#f7f5f3"},white:{main:"#ffffff"}};export{f as default};
//# sourceMappingURL=core.js.map
